import { FieldInputType } from '@lighthouse/core'
import { Controller, useFormContext } from 'react-hook-form'

import { EventList } from '@/components/EventList'

interface EventsConfigureProps {
    inputType: FieldInputType
}

export const EventsConfigure: React.FC<EventsConfigureProps> = ({ inputType }) => {
    const { control } = useFormContext()

    return (
        <Controller
            control={control}
            name="eventList"
            render={({ field }) => <EventList blockType="field" field={{ inputType }} value={field.value} onChange={field.onChange} />}
        />
    )
}
